var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLanguage({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.263 12.947L9.149 7.381a.557.557 0 00-.545-.447H7.49a.557.557 0 00-.546.447l-1.113 5.566a.557.557 0 101.092.219l.356-1.78h1.536l.356 1.78a.557.557 0 101.092-.219zM7.5 10.274l.446-2.226h.2l.446 2.226H7.5zM19.18 11.387h-1.67v-.557a.557.557 0 00-1.114 0v.557h-1.67a.557.557 0 100 1.113h.135a6.963 6.963 0 001.32 2.441c-.427.392-.86.712-1.246 1.02a.557.557 0 10.696.87c.388-.31.852-.655 1.322-1.086.47.432.936.777 1.322 1.086a.557.557 0 10.696-.87c-.385-.307-.818-.628-1.246-1.02a6.963 6.963 0 001.32-2.441h.135a.557.557 0 000-1.113zm-2.227 2.736a5.86 5.86 0 01-.916-1.627h1.832a5.864 5.864 0 01-.916 1.627z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.33 6.377H12.3l-.239-1.914A1.673 1.673 0 0010.404 3H4.67C3.75 3 3 3.75 3 4.67v12.283c0 .92.75 1.67 1.67 1.67h4.694l.235 1.914A1.674 1.674 0 0011.256 22h9.074c.92 0 1.67-.75 1.67-1.67V8.047c0-.92-.75-1.67-1.67-1.67zM4.67 17.51a.557.557 0 01-.557-.557V4.67c0-.307.25-.557.557-.557h5.734c.28 0 .518.21.552.488l1.61 12.909H4.67zm6.001 2.625l-.186-1.512h1.494l-1.308 1.512zm10.216.195c0 .307-.25.557-.557.557h-8.837l2.12-2.451a.556.556 0 00.134-.447L12.438 7.49h7.892c.307 0 .557.25.557.557V20.33z"
  })));
}

export default SvgLanguage;